<template>
  <div class="flex flex-col justify-between h-[72px] border-b-[1px] border-border py-[4px]">
    <div class="flex items-center gap-x-[12px] px-[0px]">
      <div class="rounded-[8px] bg-gray-200 w-[48px] h-[48px] animate-pulse"></div>
      <div class="flex-1 h-[24px] bg-gray-200 rounded animate-pulse"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingCompanyHeader",
};
</script>

<style scoped></style>
